import { memo } from "react";
import Box from "../Box";

type Props = {
	progress: number;
	activeColor: string;
	trackColor: string;
	stopColor: string;
	showPlayhead?: boolean;
	showEndStop?: boolean;
};

const TRACK_HEIGHT = 4;
const DOT_SIZE = 4;
const CONTAINER_HEIGHT = 12;

const FlatProgress = ({
	progress,
	activeColor,
	trackColor,
	stopColor,
	showPlayhead = false,
	showEndStop = true,
}: Props) => {
	const pct = Math.max(0, Math.min(1, progress));

	return (
		<Box
			flex={1}
			height={CONTAINER_HEIGHT}
			justifyContent="center"
			position="relative"
		>
			<Box
				height={TRACK_HEIGHT}
				borderRadius={TRACK_HEIGHT / 2}
				backgroundColor={trackColor}
				width="100%"
			/>
			{pct > 0 && (
				<Box
					position="absolute"
					height={TRACK_HEIGHT}
					borderRadius={TRACK_HEIGHT / 2}
					backgroundColor={activeColor}
					style={{ left: 0, top: (CONTAINER_HEIGHT - TRACK_HEIGHT) / 2 }}
					width={`${pct * 100}%`}
				/>
			)}
			{showPlayhead && pct > 0 && pct < 1 && (
				<Box
					position="absolute"
					width={DOT_SIZE}
					height={DOT_SIZE}
					borderRadius={DOT_SIZE / 2}
					backgroundColor={activeColor}
					style={{
						left: `${pct * 100}%`,
						top: (CONTAINER_HEIGHT - DOT_SIZE) / 2,
						marginLeft: -(DOT_SIZE / 2),
					}}
				/>
			)}
			{showEndStop && (
				<Box
					position="absolute"
					width={DOT_SIZE}
					height={DOT_SIZE}
					borderRadius={DOT_SIZE / 2}
					backgroundColor={stopColor}
					style={{
						right: 0,
						top: (CONTAINER_HEIGHT - DOT_SIZE) / 2,
					}}
				/>
			)}
		</Box>
	);
};

export default memo(FlatProgress);
